import BootstrapDialog from 'bootstrap4-dialog';

logit.classes.ButtonSelectionModal = class ButtonSelectionModal {
    constructor(containerId, title, size, selectionButtons, footerButtons) {
        'use strict';
        this.containerId = containerId;
        this.title = title;
        this.size = size || BootstrapDialog.SIZE_NORMAL;
        this.selectionButtons = selectionButtons;
        this.footerButtons = footerButtons;
    }
};